import React from 'react';
import { Link } from 'react-router-dom';
import { getUserEmailFromToken, clearAuthToken } from '../utils/auth';

const Header: React.FC = () => {
  const userEmail = getUserEmailFromToken();

  // Extract display name from email (part before @)
  const displayName = userEmail ? userEmail.split('@')[0] : null;

  const handleLogout = () => {
    clearAuthToken();
    // Full navigation rather than a router push, so no in-memory state keeps
    // rendering against a cleared token.
    window.location.assign('/');
  };

  return (
    <header className="flex-shrink-0 px-4 py-4 md:px-6 md:py-6 lg:px-10 lg:py-8" role="banner">
      <div className="flex items-center justify-between gap-4">
        <Link to="/" className="inline-flex items-baseline gap-2" aria-label="Competensys Gesprekskompas">
          <img
            src={`${process.env.PUBLIC_URL}/assets/logo.svg`}
            alt="Competensys Gesprekskompas"
            className="h-9"
          />
        </Link>

        {userEmail && (
          <div className="flex items-center gap-2 md:gap-3">
            <div
              className="w-12 h-12 lg:w-17 lg:h-17 rounded-md bg-brand-blauw/20 flex items-center justify-center overflow-hidden"
              aria-hidden="true"
            >
              <span className="text-brand-blauw font-semibold text-lg lg:text-xl">
                {displayName?.charAt(0).toUpperCase()}
              </span>
            </div>
            <div className="flex flex-col items-start gap-1">
              <p className="font-medium text-sm md:text-base text-brand-blauw truncate max-w-[116px] lg:max-w-full">
                {displayName}
              </p>
              <button
                type="button"
                onClick={handleLogout}
                className="btn-roll-effect cursor-pointer"
              >
                <span className="btn-accent btn-accent-small p-2.5">
                  Uitloggen
                </span>
                <span
                  className="btn-roll-circle btn-roll-circle-small bg-brand-red p-1.5"
                  aria-hidden="true"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                    <path d="M0.706961 0.71235L11.3136 11.319M11.3135 0.707107L0.706896 11.3137" stroke="#F1E9DD" strokeWidth="2"/>
                  </svg>
                </span>
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
